import React from "react";
import { DateInput, FileInput, FileField } from "react-admin";

/** Employee document expiry dates and uploads.
 * Existing single-file keys are retained as page/front fields for backward compatibility.
 */
export const DriverExpiryInputs = () => {
  const rowStyle = { display: "flex", alignItems: "flex-start", gap: "16px", marginBottom: "12px" };
  const fileInputProps = { accept: "image/*,application/pdf", label: "Upload File" };

  const Upload = ({ source, title }) => (
    <div style={{ flex: 1 }}>
      <FileInput source={source} {...fileInputProps} label={title}>
        <FileField source="src" title={title} />
      </FileInput>
    </div>
  );

  return (
    <div style={{ marginTop: 20 }}>
      <h4 style={{ marginBottom: 12 }}>Document Expiry Dates & Uploads</h4>

      <div style={rowStyle}>
        <div style={{ flex: 1 }}><DateInput source="passportExpiry" label="Passport Expiry" /></div>
        <Upload source="passportFile" title="Passport Page 1" />
        <Upload source="passportFileBack" title="Passport Page 2" />
      </div>

      <div style={rowStyle}>
        <div style={{ flex: 1 }}><DateInput source="emiratesIdExpiry" label="Emirates ID Expiry" /></div>
        <Upload source="emiratesIdFile" title="Emirates ID Front" />
        <Upload source="emiratesIdFileBack" title="Emirates ID Back" />
      </div>

      <div style={rowStyle}>
        <div style={{ flex: 1 }}><DateInput source="licenseExpiry" label="Driving License Expiry" /></div>
        <Upload source="licenseFile" title="Driving License Front" />
        <Upload source="licenseFileBack" title="Driving License Back" />
      </div>

      <div style={rowStyle}>
        <div style={{ flex: 1 }}><DateInput source="rtaPermitExpiry" label="RTA Permit Expiry" /></div>
        <Upload source="rtaPermitFile" title="RTA Permit" />
      </div>

      <div style={rowStyle}>
        <div style={{ flex: 1 }}><DateInput source="rtaTrainingExpiry" label="RTA Training Expiry" /></div>
        <Upload source="rtaTrainingFile" title="RTA Training" />
      </div>

      <div style={rowStyle}>
        <div style={{ flex: 1 }}><DateInput source="healthInsuranceExpiry" label="Health Insurance Expiry" /></div>
        <Upload source="healthInsuranceFile" title="Health Insurance" />
      </div>
    </div>
  );
};
